import React from "react";
import { createPortal } from "react-dom";
import { FaTimes, FaExclamationTriangle } from "react-icons/fa";
import { PrimaryButton, DangerButton } from "./Buttons";

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger", // "danger" or "warning"
  loading = false,
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div
                className={`h-10 w-10 rounded-full flex items-center justify-center ${
                  variant === "danger" ? "bg-red-100" : "bg-yellow-100"
                }`}
              >
                <FaExclamationTriangle
                  className={`h-5 w-5 ${
                    variant === "danger" ? "text-red-600" : "text-yellow-600"
                  }`}
                />
              </div>
            </div>
            <div className="ml-4">
              <h3 className="text-lg font-medium text-gray-900">{title}</h3>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 rounded-md p-1"
          >
            <FaTimes className="h-5 w-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-sm text-gray-600">{message}</p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 px-6 py-4 bg-gray-50 rounded-b-lg">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {cancelText}
          </button>
          {variant === "danger" ? (
            <DangerButton
              onClick={onConfirm}
              disabled={loading}
              loading={loading}
            >
              {confirmText}
            </DangerButton>
          ) : (
            <PrimaryButton
              onClick={onConfirm}
              disabled={loading}
              loading={loading}
            >
              {confirmText}
            </PrimaryButton>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog;
